export function createProductAttributeSortInput(sortData) {
    const baseData = sortData.split(/_/gi);
    return baseData.length > 0 ? Object.fromEntries([baseData]) : {};
}
